export const fulfillmentResources = {
  'fulfillment.config.title': 'Fulfillment Center Configuration',
  'fulfillment.config.addFC': 'Add FC',
  'fulfillment.config.fcInfo': 'FC Info',
  'fulfillment.config.shipDays': 'Shipping Days',
  'fulfillment.config.contact': 'Contact Info',
  'fulfillment.config.processingDays': 'Processing Days',
  'fulfillment.config.holidays': 'Holidays',
  'fulfillment.config.shippingCapabilities': 'Shipping Capabilities',
  'fulfillment.config.sameDayShippingDescription': `Can this FC guarantee shipments ordered today before a certain time will be shipped today?`,
  'fulfillment.config.nextDayShippingDescription': `Can this FC guarantee shipments ordered today before a certain time will be shipped tomorrow?`,
  'fulfillment.config.sameDayShippingLabel': 'Same-Day Shipping',
  'fulfillment.config.nextDayShippingLabel': 'Next-Day Shipping',
  'fulfillment.config.cutOffTime': 'Cutoff Time',
  'fulfillment.config.customShipCapabilitiesDescription':
    'When can the FC guarantee shipments ordered today will go out?',
  'fulfillment.config.nextButtonWarning': 'You must set your FC shipping capabilities to continue',
  'fulfillment.config.cutOffTimeRequired': 'You must set a cutoff time',
  'fulfillment.config.nextButtonAllowed': 'Continue to Holidays setup',
  'fulfillment.config.holidayHelperMessage': 'Specify holidays on which the FC will not ship',
};

export type FulfillmentResourceKey =
  | 'fulfillment.config.holidayHelperMessage'
  | 'fulfillment.config.title'
  | 'fulfillment.config.addFC'
  | 'fulfillment.config.fcInfo'
  | 'fulfillment.config.shipDays'
  | 'fulfillment.config.contact'
  | 'fulfillment.config.processingDays'
  | 'fulfillment.config.holidays'
  | 'fulfillment.config.shippingCapabilities'
  | 'fulfillment.config.sameDayShippingDescription'
  | 'fulfillment.config.nextDayShippingDescription'
  | 'fulfillment.config.sameDayShippingLabel'
  | 'fulfillment.config.nextDayShippingLabel'
  | 'fulfillment.config.cutOffTime'
  | 'fulfillment.config.customShipCapabilitiesDescription'
  | 'fulfillment.config.nextButtonWarning'
  | 'fulfillment.config.cutOffTimeRequired'
  | 'fulfillment.config.nextButtonAllowed';
